import { ChangeDetectionStrategy, Component, HostBinding, Inject, Input, ViewEncapsulation } from "@angular/core";
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from "@angular/material/legacy-dialog";
import { NavbarOptions } from "@obg/mat.ui.core";
import { TermsAndConditionsVersionContent } from "@obg/ngx.common";
import { DeviceConfigService } from "@obg/ngx.global";

@Component({
	selector: "obg-m-terms-and-conditions-modal-container",
	templateUrl: "./terms-and-conditions-modal.container.html",
	styleUrls: ["./terms-and-conditions-modal.container.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class TermsAndConditionsModalContainer {
	@HostBinding("class.obg-m-terms-and-conditions-modal") class = true;

	@Input() dialogId: string | undefined;

	isMobile = !this.deviceConfigService.isDesktop();
	showNavbar = this.isMobile;
	navbarOptions: NavbarOptions = {
		showCloseButton: this.isMobile,
		preventDefaultBack: this.isMobile,
		hideBackButton: this.isMobile,
	};

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: TermsAndConditionsVersionContent,
		private deviceConfigService: DeviceConfigService
	) {}
}
